import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";

export async function uploadFile(file, path) {
    const storage = getStorage();

    const fileRef = ref(storage, path)

    return uploadBytes(fileRef, file).then(snapshot => getDownloadURL(snapshot.ref))
}